import axios, { getData } from "lib/axios"


export const getCreditBalance = async () => {
    const response = await axios
        .get(`/recruitment/credit-account`)
    return getData(response)
  }
export const getCreditPackage = async () => {
    const response = await axios
        .get(`/recruitment/credit-account/packages`)
    return getData(response)
  }